import React, { createContext, useContext, useState, useRef, useCallback } from 'react';

export const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [message, setMessage] = useState(null);
  const timer = useRef(null);

  const showToast = useCallback((text) => {
    setMessage(text);

    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setMessage(null), 4000);
  }, []);

  const value = { message, showToast };

  return (
    <ToastContext.Provider value={value}>
      {children}
      {message && (
        <div role="status" className="toast">
          {message}
        </div>
      )}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);

  if (context === null) {
    throw new Error('useToast must be used within a ToastProvider');
  }

  return context;
};
